import "./index.css";

const Certification = () => {
  return (
    <div className="certificate">
      <img
        src="https://iqteche.in/static/media/wl_client_images/3efc285f8b084ea19436cbe89aff9e0d.png"
        alt="certification"
      />
    </div>
  );
};

export default Certification;
